// extracted by mini-css-extract-plugin
module.exports = {"productLink":"HorizontalLinks_productLink__24W95"};